import React, { useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import coursesData from "../data/coursesData.json";
import { CheckCircle } from "lucide-react";

const CourseDetailPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const course = coursesData.courses.find((c) => c.id === parseInt(id));
  const [openModuleIndex, setOpenModuleIndex] = useState(null);
  const curriculumCategories = coursesData.categories;
  if (!course) {
    return <p className="text-center mt-20 text-xl">Course not found!</p>;
  }


  const toggleModule = (index) => {
    setOpenModuleIndex(openModuleIndex === index ? null : index);
  };
  return (
    <section className="bg-gray-50 min-h-screen">
      <div className="relative w-full h-[400px] md:h-[500px]">
        <img
          src={course.image}
          alt={course.title}
          className="w-full h-full object-cover"
        />

      </div>

      <div className="max-w-6xl mx-auto px-6 md:px-16 py-16 space-y-16">

        <div>
          <h2 className="text-3xl font-bold text-gray-800 mb-4 uppercase text-start">Course Overview</h2>
          <p className="text-gray-700 text-lg leading-relaxed text-start">
            {course.description}
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 gap-6">
          {[
            { label: "Course Duration", value: "12 Months" },
            { label: "Level", value: "Beginner – Advanced" },
            { label: "Language", value: "English" },
          ].map((info, i) => (
            <div key={i} className="bg-white rounded-2xl shadow p-6 text-center">
              <h3 className="font-semibold text-gray-700">{info.label}</h3>
              <p className="text-gray-900 text-lg font-bold mt-2">{info.value}</p>
            </div>
          ))}
        </div>

        {course.keyTopics?.length > 0 && (
  <div>
    <h2 className="text-3xl font-bold text-gray-800 mb-6">
      What You’ll Learn
    </h2>

    <div
      className="grid grid-flow-col gap-6"
      style={{
        gridTemplateRows: `repeat(${Math.ceil(course.keyTopics.length / 2)}, minmax(0, 1fr))`
      }}
    >
      {course.keyTopics.map((topic, index) => (
        <div key={index} className="flex items-start gap-3">
          <CheckCircle className="text-green-600 w-5 h-5 mt-1 shrink-0" />
          <p className="text-lg text-gray-700 leading-relaxed text-left">
            {topic}
          </p>
        </div>
      ))}
    </div>
  </div>
)}



        {/* Curriculum Section */}
        <div className="space-y-6">
          {curriculumCategories?.map((cat, i) => {
            const isOpen = openModuleIndex === i;

            return (
              <div key={i} className="border rounded-xl bg-white shadow">
                {/* Module Header */}
                <button
                  onClick={() => toggleModule(i)}
                  className="w-full flex justify-between items-center p-4 font-semibold text-gray-800 text-left"
                >
                  <span>{cat.category}</span>
                  <span>{isOpen ? "▲" : "▼"}</span>
                </button>

                {/* Module Content */}
                {isOpen && (
                  <ul className="p-4 space-y-4">
                    {cat.itemIds.map((itemId) => {
                      const item = coursesData.courses.find((c) => c.id === itemId);
                      if (!item) return null;
                      return (
                        <li
                          key={item.id}
                          className="bg-gray-50 p-4 rounded-xl shadow-sm"
                        >
                          <div className="flex items-center justify-between">
                            <span className="text-lg font-semibold text-gray-700">
                              {item.title}
                            </span>
                            <CheckCircle className="text-green-500 w-5 h-5" />
                          </div>
                          <p className="mt-2 text-gray-600 text-start">{item.description}</p>
                        </li>
                      );
                    })}
                  </ul>
                )}
              </div>
            );
          })}
        </div>


        {/* Instructor */}
        <div className="bg-white rounded-2xl shadow p-8 flex flex-col md:flex-row items-center gap-8">
          <img
            src="https://placehold.co/180x180/6366F1/FFFFFF?text=Instructor"
            alt="Instructor"
            className="rounded-full w-40 h-40 object-cover"
          />
          <div>
            <h2 className="text-2xl font-bold text-start text-gray-800 mb-2">Meet Your Instructor</h2>
            <p className="text-gray-700 text-lg leading-relaxed text-start">
              <strong>John Doe</strong> – With 10+ years in the industry, John has mentored
              hundreds of students and worked on global projects. He specializes in
              blending academic knowledge with real-world applications, making learning
              highly engaging and practical.
            </p>
          </div>
        </div>
      </div>

      {/* Sticky CTA */}
      <div className=" bottom-0 bg-white shadow-lg py-4 px-6 flex flex-col md:flex-row items-center justify-between gap-4">
        <span className="text-xl font-bold text-gray-800">
          Ready to start your journey?
        </span>
        <div className="flex gap-4">
          <button
            onClick={() => navigate("/courses")}
            className="px-6 py-3 rounded-full font-semibold bg-gray-200 hover:bg-gray-300"
          >
            Back to Courses
          </button>
          <Link
            to="/contact-us"
            className="px-6 py-3 rounded-full font-semibold text-white bg-gradient-to-r from-pink-500 to-purple-600 hover:from-pink-600 hover:to-purple-700"
          >
            Enroll Now
          </Link>
        </div>
      </div>
    </section>
  );
};

export default CourseDetailPage;
